import { useEffect } from "react";
import UrlRoutes from "./routes/UrlRoutes";
import store from "./redux/store";
import {Provider} from "react-redux";
import {Slide, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-tooltip/dist/react-tooltip.css'
import {MaintenancePage} from "./pages/MaintenancePage/MaintenancePage";
import {IS_APP_MAINTENANCE} from "./utils/constants";
import { BrandProvider } from "./context/BrandContext";
import { initFacebookSdk } from "./utils/facebookSdk";

function App() {
    useEffect(() => {
        initFacebookSdk();
    }, []);
    return (
        <BrandProvider>
        <>{IS_APP_MAINTENANCE === 'false' ?
            <>
                <Provider store={store}>
                    <UrlRoutes/>
                </Provider>
                <ToastContainer toastContainerClassName="custom-toast-container" transition={Slide}/></> :
            <MaintenancePage/>
        }
        </>
        </BrandProvider>
    );
}

export default App;